<div class="auth-main particles_js">
    <div class="auth_div vivify popIn" style="width: 50%;">
        <div class="auth_brand">
        </div>
        <div class="card">


              <div class="card-header"><h4>Recuperar Contraseña</h4></div>

              <div class="card-body">
                <form method="POST" #recuperarForm="ngForm" (ngSubmit)="onSubmit(recuperarForm)">
                  
                    <div class="alert alert-primary" *ngIf="status == 'success'">
                        {{message}}
                    </div>
                
                    <div class="alert alert-danger" *ngIf="status == 'error'">                            
                        {{message}}
                    </div>
                 
                  <div class="row">
                    <div class="form-group col-6">
                      <label for="password" class="d-block">Contraseña</label>
                      <input id="password" [attr.minlength]="8" type="text" [ngClass]="{'is-invalid' : pass == 'error'}" class="form-control" #password="ngModel" [(ngModel)]="user.password"  name="password" required autocomplete="new-password">
                    
                        <span class="invalid-feedback" role="alert">
                            <strong>La contraseña no coinciden</strong>
                        </span>
                
                      <div id="pwindicator" class="pwindicator">
                        <div class="bar"></div>
                        <div class="label"></div>
                      </div>
                    </div>
                    <div class="form-group col-6">
                      <label for="password2" class="d-block">Confirmar Contraseña</label>
                        <input id="password-confirm" [attr.minlength]="8" [ngClass]="{'is-invalid' : pass == 'error'}" type="password" class="form-control"  #img="ngModel" [(ngModel)]="user.img" name="password_confirmation" required autocomplete="new-password">
                    </div>
                  </div>
                  <div class="form-group">
                    <button type="submit" class="btn btn-primary  btn-round btn-block" [disabled]="!recuperarForm.form.valid">
                      <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loading, ' fa-refresh fa-spin':loading }"></i>
                      Cambiar Contraseña
                      </button>
                  </div>
              

                </form>
              </div>
            </div>
    </div>
    <div id="particles-js"></div>
</div>